import { render, staticRenderFns } from "./RichText.vue?vue&type=template&id=14420093"
import script from "./RichText.vue?vue&type=script&lang=ts"
export * from "./RichText.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports